import React from 'react';

const HeaderV2 = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 max-w-screen-2xl items-center justify-between">
        <div className="flex items-center gap-2">
          {/* Logo or Professional Name */}
          <span className="font-bold text-xl tracking-tight">Juliano Wagner</span>
        </div>
        
        <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
          <a href="#metodo" className="transition-colors hover:text-foreground/80 text-foreground/60">Método</a>
          <a href="#custos-riscos" className="transition-colors hover:text-foreground/80 text-foreground/60">Custos e riscos</a>
          <a href="#faq" className="transition-colors hover:text-foreground/80 text-foreground/60">Perguntas</a>
        </nav>

        <div className="flex items-center gap-4">
          <a 
            href="#diagnostico" 
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow hover:bg-primary/90 h-9 px-4 py-2"
          >
            Fazer diagnóstico
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeaderV2;
